export default {
  activation_error: {
    title: 'Hubo un error activando su cuenta',
    subtitle: 'Contacta a soporte para resolver el problema.'
  },
  activating_account: {
    title: 'Espera un momento,',
    subtitle: 'tu cuenta está siendo activada.',
    subtitleDescription: 'Al finalizar el proceso, será redireccionado automáticamente.'
  },
  landing_activation: {
    title: 'Activación de cuenta',
    tittle_google: 'Su Colegio ya cuenta con Google for Education',
    token_label: 'Token: ',
    description: 'Elija una de las siguentes opciones para activar su cuenta:',
    description_aluzo: 'Esto te permite tener acceso a nuestras plataformas y conservar tu información de ciclos pasados.',
    description_google: 'Active su cuenta utilizando el correo institucional de su colegio.',
    new_button: 'Crear cuenta nueva',
    existing_button: 'Ya tengo cuenta',
    invalid_token: 'El Token ingresado no existe o es inválido.',
    invalid_token_length: 'El Token ingresado es demasiado corto.',
    activated_token: 'El Token ingresado ya fue activado.',
    amco_account: 'Utiliza tu cuenta Amco',
    login_title: 'Si ya tienes una cuenta ingresa tus datos',
    login_with_google: 'Inicia sesión con Google',
    google_domain_info: 'La cuenta de correo google de su colegio tiene la terminación: {domain}',
    google_domain_info_error: 'La cuenta de correo google que ha proporcionado no es válida. Por favor utilice su cuenta google con terminación: {domain}',
    google_user_info_error: 'La cuenta de correo google {account} que ha proporcionado ya fue activada para el año {year}. Utilice otra cuenta google con terminación: {domain}',
    invalid_api_version: 'El token que intentas activar es para un ciclo anterior, tu administrador de escuela se encargará de tu acceso',
    forgot_account: '¿Olvidaste tu contraseña o usuario?',
    forgot_account_google: 'Si olvidó la contraseña, no recuerda su correo institucional o no tiene una cuenta institucional, contacte al administrador de su colegio.',
    create_account: '¿Eres nuevo? ¿Aún no tienes cuenta?',
    login: 'Iniciar sesión',
    invalid_username_password: 'El nombre de usuario o contraseña es incorrecta.',
  },
  creating_account: {
    title: 'Crea una nueva cuenta',
    description: 'Recuerda que si ya tienes una cuenta Amco y creas una nueva perderás acceso a toda la información que habías creado con tu cuenta original.',
    create_account: '¿Estás seguro que necesitas crear una nueva cuenta?',
    activate: 'Activar',
    back: 'Regresar',
    title_modal: 'Su colegio cuenta con Google for Education',
    info_modal: 'Active su cuenta utilizando el correo institucional de su colegio, para ello será enviado a un portal de activación especial.'
  },
  labels: {
    personal_info: 'Información personal',
    name: 'Nombre',
    last_name: 'Apellido',
    email: 'Correo electrónico de recuperación',
    email_disclaimer: 'El correo electrónico de recuperación te ayudará a acceder a la plataforma si haz olvidado como ingresar.',
    username: 'Nombre de usuario',
    username_disclaimer: 'El nombre de usuario deberá contener letras y números. No acepta espacios o caracteres especiales.',
    password: 'Contraseña',
    password_confirm: 'Confirmar contraseña',
    password_disclaimer: 'Deberá contener al menos 8 caracteres de longitud.',
    login_username: 'Nombre de usuario o correo electrónico'
  },
  errors: {
    invalid_username: 'Usuario invalido',
    invalid_recovery_email: 'Correo de recuperación invalido',
    invalid_password: 'Las contraseñas no son iguales',
    invalid_password_length: 'La contraseña es demasiado corta',
    invalid_password_characters: 'No debe tener caracteres especiales',
    invalid_request: 'La solicitud no puede ser procesada',
    invalid_token: 'El Token ingresado no existe o es inválido.',
    invalid_token_service: 'El token que intentas activar es para otro servicio, usa este link: ',
    invalid_token_expired: 'El código ha expirado , contacta a tu administrador del colegio.',
    invalid_token_expired_aluzo: 'Lo sentimos, el token proporcionado está expirado.',
    invalid_token_aluzo: 'Lo sentimos, el token proporcionado no es válido.',
    invalid_email: 'Lo sentimos, el correo electrónico proporcionado no es válido.'
  },
  information: {
    token: 'El token es un código único que funciona como una llave personal para activar su cuenta Amco.',
    email: 'El correo electrónico de recuperación te ayudará a acceder a la plataforma si has olvidado cómo ingresar.',
    username: 'El nombre de usuario deberá contener solo letras (a - z) y números (0-9). No acepta espacios o caracteres especiales.'
  }
}
